'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'cube';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1b2';
var svgPathData = ['M64.5 173l0 184.6c0 5.7 3 11 8 13.9l159.8 92.3 0-193.8-167.8-96.9zm24-41.6l167.8 96.9 167.8-96.9-159.8-92.3c-5-2.9-11-2.9-16 0L88.5 131.4z', 'M248.3 39.1c5-2.9 11-2.9 16 0l159.8 92.3-167.8 96.9-167.8-96.9 159.8-92.3zM64.5 173l167.8 96.9 0 193.8-159.8-92.3c-5-2.9-8-8.1-8-13.9l0-184.6zM280.3 463.7l0-193.8 167.8-96.9 0 184.6c0 5.7-3 11-8 13.9L280.3 463.7zm8-466.1c-19.8-11.4-44.2-11.4-64 0L48.5 99c-19.8 11.4-32 32.6-32 55.4l0 203c0 22.9 12.2 44 32 55.4L224.3 514.5c19.8 11.4 44.2 11.4 64 0L464.2 413c19.8-11.4 32-32.6 32-55.4l0-203c0-22.9-12.2-44-32-55.4L288.3-2.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCube = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;